import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import {
    REDIRECTIONS,
    ModalService,
    AnalyticsService,
    VIRTUAL_PAGEVIEWS as PAGES,
} from '@sm360/widget-commons-general';

import TradeInValueSuccess from 'trade-in/components/TradeInValueSuccess/TradeInValueSuccess.jsx';

import 'trade-in/components/ConfirmationStep/ConfirmationStep.scss';

const OfficialTradeInModal = ModalService.get('trade-in-official-modal');

class ConfirmationStep extends Component {
    componentWillMount() {
        this.props.onTradeInSuccess();
    }
    componentDidMount() {
        AnalyticsService.virtualPageView(PAGES.OFFICIAL_TRADEIN_THANKS());
    }
    closeModal() {
        OfficialTradeInModal.close();
    }

    redirectToHomepage() {
        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            windowProxy.location.assign(REDIRECTIONS[LocaleService.getSimpleLocale()].homepage);
        }
    }
    render() {
        return (
            <div>
                <TradeInValueSuccess />
                <button
                    className="sr-link continue-shopping"
                    onClick={this.props.isRenderedInModal ? this.closeModal : this.redirectToHomepage}
                    dataTest="trade-in.trade-in-cta.confirmation.continue-shopping"
                >
                    {LocaleService.t('TRADE_IN.CTA.BACK_TO_SHOP.TITLE')}
                </button>
            </div>
        );
    }
}

ConfirmationStep.propTypes = {
    onTradeInSuccess: PropTypes.func.isRequired,
    isRenderedInModal: PropTypes.bool.isRequired,
};

ConfirmationStep.displayName = 'ConfirmationStep';

export default ConfirmationStep;
